import { METERS_PER_CSS_PIXEL } from './pageUnits';

/** Web-Mercator equatorial resolution at zoom 0 (EPSG:3857). */
const MERCATOR_METERS_PER_PIXEL_Z0 = 156543.03392804097;

export function estimateScaleDenominator(
  zoom: number,
  latitudeDeg: number,
): number | null {
  if (!Number.isFinite(zoom) || !Number.isFinite(latitudeDeg)) return null;
  const latitudeRad = (latitudeDeg * Math.PI) / 180;
  const metersPerPixel =
    (MERCATOR_METERS_PER_PIXEL_Z0 * Math.cos(latitudeRad)) / Math.pow(2, zoom);
  if (!Number.isFinite(metersPerPixel) || metersPerPixel <= 0) return null;
  return metersPerPixel / METERS_PER_CSS_PIXEL;
}
